import { render, staticRenderFns } from "./taxoutsidePayroll.vue?vue&type=template&id=2c2ea340&scoped=true"
import script from "./taxoutsidePayroll.vue?vue&type=script&lang=js"
export * from "./taxoutsidePayroll.vue?vue&type=script&lang=js"
import style0 from "./taxoutsidePayroll.vue?vue&type=style&index=0&id=2c2ea340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2ea340",
  null
  
)

export default component.exports